exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1XrlT{background:#f3d8d8}._3vZ4g{background:#bce0bc}._3TeWN{padding:0!important}._3SmZZ{padding:7px 3px}.zuOLn div{overflow-x:hidden!important}.zuOLn div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"noProcesada": "_1XrlT",
	"procesada": "_3vZ4g",
	"tdClear": "_3TeWN",
	"field": "_3SmZZ",
	"hidden": "zuOLn"
};